"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _styles = require("@material-ui/core/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _styles2 = require("../utilities/styles");
var _camelCase = _interopRequireDefault(require("../poly/camelCase"));
var _excluded = ["classes", "indicatorType", "indicatorColor", "customSelectColor"],
  _excluded2 = ["focusVisibleClassName", "root"];
var useClasses = (0, _styles.makeStyles)(function (_ref) {
  var _root, _defaultRoot, _pillSelected;
  var palette = _ref.palette,
    breakpoints = _ref.breakpoints,
    highContrast = _ref.accessibility.highContrast,
    typography = _ref.typography;
  return {
    root: (_root = {
      opacity: 1,
      margin: '4px !important',
      letterSpacing: '.6px',
      whiteSpace: 'nowrap',
      maxWidth: 'initial',
      fontSize: typography.h5.fontSize
    }, (0, _defineProperty2.default)(_root, breakpoints.down('md'), {
      minWidth: 'auto'
    }), (0, _defineProperty2.default)(_root, '&:hover', (0, _defineProperty2.default)({
      color: function color(_ref2) {
        var indicatorColor = _ref2.indicatorColor,
          customSelectColor = _ref2.customSelectColor;
        return customSelectColor ? customSelectColor : palette.button.contained[indicatorColor].backgroundColor;
      }
    }, highContrast.mediaQuery('active'), {
      color: 'Highlight !important',
      textDecoration: 'underline 2px'
    })), _root),
    defaultRoot: (_defaultRoot = {}, (0, _defineProperty2.default)(_defaultRoot, breakpoints.down('md'), {
      paddingLeft: 0,
      paddingRight: 0
    }), (0, _defineProperty2.default)(_defaultRoot, '&:first-child', (0, _defineProperty2.default)({
      marginRight: '.4em'
    }, breakpoints.only('sm'), {
      marginRight: '.6em'
    })), (0, _defineProperty2.default)(_defaultRoot, '&:not(:first-child):not(:last-child)', (0, _defineProperty2.default)({
      marginLeft: '.4em',
      marginRight: '.4em'
    }, breakpoints.only('sm'), {
      marginLeft: '.6em',
      marginRight: '.6em'
    })), (0, _defineProperty2.default)(_defaultRoot, '&:last-child', (0, _defineProperty2.default)({
      marginLeft: '.4em'
    }, breakpoints.only('sm'), {
      marginLeft: '.6em'
    })), _defaultRoot),
    defaultFocusVisible: (0, _defineProperty2.default)({
      margin: '2px !important',
      color: function color(_ref3) {
        var indicatorColor = _ref3.indicatorColor,
          customSelectColor = _ref3.customSelectColor;
        return customSelectColor ? customSelectColor : palette.button.text[indicatorColor].color;
      },
      border: "2px solid ".concat(palette.text.primary, " !important"),
      outline: "2px solid ".concat(palette.background.default, " !important")
    }, highContrast.mediaQuery('active'), {
      color: 'HighlightText !important',
      background: 'Highlight !important',
      '-ms-high-contrast-adjust': 'none',
      border: "2px solid Window !important",
      outline: "2px solid WindowText !important",
      zIndex: 1
    }),
    defaultSelected: (0, _defineProperty2.default)({
      color: function color(_ref4) {
        var indicatorColor = _ref4.indicatorColor,
          customSelectColor = _ref4.customSelectColor;
        return customSelectColor ? customSelectColor : palette.button.text[indicatorColor].color;
      }
    }, highContrast.mediaQuery('active'), {
      color: 'HighlightText !important',
      background: 'Highlight !important',
      '-ms-high-contrast-adjust': 'none',
      '&:hover': {
        textDecoration: 'underline 2px',
        color: 'HighlightText !important'
      }
    }),
    pillRoot: {
      minWidth: 'initial',
      borderRadius: 10,
      color: palette.button.contained.tertiary.color,
      backgroundColor: palette.button.contained.tertiary.background,
      border: "1px solid ".concat(palette.border.secondary),
      '&:first-child': (0, _defineProperty2.default)({
        marginRight: '.15em'
      }, breakpoints.up('md'), {
        marginRight: '.5em'
      }),
      '&:not(:first-child):not(:last-child)': (0, _defineProperty2.default)({
        marginLeft: '.15em',
        marginRight: '.15em'
      }, breakpoints.up('md'), {
        marginLeft: '.5em',
        marginRight: '.5em'
      }),
      '&:last-child': (0, _defineProperty2.default)({
        marginLeft: '.15em'
      }, breakpoints.up('md'), {
        marginLeft: '.5em'
      }),
      '&:hover': {
        color: function color(_ref5) {
          var indicatorColor = _ref5.indicatorColor;
          return palette.button.contained[indicatorColor].hover.color;
        },
        backgroundColor: function backgroundColor(_ref6) {
          var indicatorColor = _ref6.indicatorColor;
          return palette.button.contained[indicatorColor].hover.background;
        },
        borderColor: function borderColor(_ref7) {
          var indicatorColor = _ref7.indicatorColor;
          return palette.button.contained[indicatorColor].hover.borderColor;
        }
      }
    },
    pillSelected: (_pillSelected = {}, (0, _defineProperty2.default)(_pillSelected, highContrast.mediaQuery('active'), {
      background: 'Highlight !important',
      color: 'HighlightText !important',
      '-ms-high-contrast-adjust': 'none',
      '&:hover': (0, _defineProperty2.default)({}, highContrast.mediaQuery('active'), {
        textDecoration: 'underline 2px'
      })
    }), (0, _defineProperty2.default)(_pillSelected, "color", function color(_ref8) {
      var indicatorColor = _ref8.indicatorColor;
      return palette.button.contained[indicatorColor].color;
    }), (0, _defineProperty2.default)(_pillSelected, "backgroundColor", function backgroundColor(_ref9) {
      var indicatorColor = _ref9.indicatorColor;
      return palette.button.contained[indicatorColor].background;
    }), (0, _defineProperty2.default)(_pillSelected, "borderColor", 'transparent'), (0, _defineProperty2.default)(_pillSelected, '&:hover, &:focus', (0, _defineProperty2.default)({
      color: function color(_ref10) {
        var indicatorColor = _ref10.indicatorColor;
        return palette.button.contained[indicatorColor].hover.color;
      },
      backgroundColor: function backgroundColor(_ref11) {
        var indicatorColor = _ref11.indicatorColor;
        return palette.button.contained[indicatorColor].hover.background;
      },
      borderColor: function borderColor(_ref12) {
        var indicatorColor = _ref12.indicatorColor;
        return palette.button.contained[indicatorColor].hover.borderColor;
      }
    }, highContrast.mediaQuery('active'), {
      color: 'HighlightText !important'
    })), _pillSelected),
    pillFocusVisible: (0, _defineProperty2.default)({
      margin: '2px !important',
      color: function color(_ref13) {
        var indicatorColor = _ref13.indicatorColor;
        return palette.button.contained[indicatorColor].hover.color;
      },
      backgroundColor: function backgroundColor(_ref14) {
        var indicatorColor = _ref14.indicatorColor;
        return palette.button.contained[indicatorColor].hover.background;
      },
      border: "2px solid ".concat(palette.background.default, " !important"),
      outline: "2px solid ".concat(palette.text.primary, " !important")
    }, highContrast.mediaQuery('active'), {
      color: 'HighlightText !important',
      background: 'Highlight !important',
      '-ms-high-contrast-adjust': 'none',
      margin: '2px !important',
      border: "2px solid Window !important",
      outline: "2px solid WindowText !important",
      zIndex: 1
    }),
    wrapper: (0, _extends2.default)({}, palette.button.labelBase)
  };
}, {
  classNamePrefix: 'TCUITab'
});
var Tab = function Tab(_ref15) {
  var classes = _ref15.classes,
    indicatorType = _ref15.indicatorType,
    indicatorColor = _ref15.indicatorColor,
    customSelectColor = _ref15.customSelectColor,
    rest = (0, _objectWithoutProperties2.default)(_ref15, _excluded);
  var _classes = useClasses({
    indicatorColor: indicatorColor,
    customSelectColor: customSelectColor
  });
  var focusVisibleClassName = classes.focusVisibleClassName,
    root = classes.root,
    restClasses = (0, _objectWithoutProperties2.default)(classes, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_Tab.default, (0, _extends2.default)({}, rest, {
    classes: (0, _styles2.mergeClasses)({
      root: (0, _clsx.default)(_classes.root, _classes[(0, _camelCase.default)([indicatorType, 'root'])], root),
      selected: _classes[(0, _camelCase.default)([indicatorType, 'selected'])],
      wrapper: _classes.wrapper,
      indicator: _classes[(0, _camelCase.default)([indicatorType, 'indicator'])]
    }, restClasses),
    focusVisibleClassName: (0, _clsx.default)(_classes[(0, _camelCase.default)([indicatorType, 'focusVisible'])], focusVisibleClassName)
  }));
};
Tab.propTypes = {
  classes: _propTypes.default.object,
  indicatorType: _propTypes.default.oneOf(['default', 'pill']),
  indicatorColor: _propTypes.default.string,
  customSelectColor: _propTypes.default.string
};
Tab.defaultProps = {
  classes: {},
  indicatorType: 'default',
  indicatorColor: 'primary',
  customSelectColor: null
};
var _default = Tab;
exports.default = _default;